export default __webpack_public_path__ + "static/media/logo.7fdb7229.webp";